import useSWR from "swr";
import { useSudowriteStore } from "../../../stores/sudowriteStore";
import {
  INSTALLATIONS_LIST_KEY,
  INSTALLATIONS_LIST_SWR_OPTIONS,
  createInstalledPluginsFetcher,
} from "../../../hooks/installedPluginsListCache";

const useInstalledPlugins = ({ category, user }) => {
  const cachedInstalledPlugins = useSudowriteStore((state) => state.installedPlugins);
  const setInstalledPlugins = useSudowriteStore((state) => state.setInstalledPlugins);
  const fetcher = createInstalledPluginsFetcher({
    requestSource: "plugin-gallery-installed-plugins",
    onFetched: setInstalledPlugins,
  });
  const { data, error, isLoading, mutate } = useSWR(
    () => (user ? INSTALLATIONS_LIST_KEY : null),
    fetcher,
    INSTALLATIONS_LIST_SWR_OPTIONS,
  );

  // Reuse the global plugin list while SWR retries transient body-read failures
  // so the gallery does not briefly look like the user has no installations.
  let plugins = data || (user ? cachedInstalledPlugins : []) || [];

  plugins = plugins.map((installation) => installation.plugin).filter((p) => {
    return p.categoryId !== "first-party-plugins";
  });

  if (category?.id) {
    plugins = plugins.filter(plugin => plugin.categoryId === category?.id);
  }

  plugins.sort((a, b) => a.name.localeCompare(b.name));

  return {
    plugins,
    load: mutate,
    isLoading,
    error,
  };
};

export default useInstalledPlugins;
